import * as api from '../api';

export function toponimySearch(map) {
    Promise.all([
        api.getGroupServiceByName('toponymie'),
        api.getGroupServiceByName('overlay-search').catch(() => ({ services: [] }))
    ]).then(([{ services: toponymieServices }, { services: overlayServices }]) => {
        window.goto = (lat, lng, service, id, type) => {
            if (service === 'overlay' && id && type !== 'balise_vtt' && type !== 'balise_PDIPR') {
                const layer = L.internalOverlayLayer._instances.find(i => i._type.name === type);
                if (layer) {
                    if (!map.hasLayer(layer)) {
                        map.addLayer(layer);
                    }

                    map.setView(L.latLng(lat, lng), 16);

                    const featureLayer = layer.getLayers().find(l => l.feature.id == id);
                    if (featureLayer) {
                        featureLayer.fire('click', { latlng: L.latLng(lat, lng) });
                    } else {
                        api.getInternalOverlayById(id).then(feature => {
                            L.overlayPopup(feature.properties, { latlng: L.latLng(lat, lng), featureId: feature.id })
                                .setLatLng(L.latLng(lat, lng))
                                .addTo(map)
                                .openOn(map);
                        });
                    }
                    return;
                }
            }

            const template = Handlebars.templates['coordinates-result'];
            const isEventDetails = map.eventId !== null && map.eventId !== undefined;
            const popupHtml = template({
                lat: lat,
                lng: lng,
                isEventDetails: isEventDetails
            });

            L.marker(L.latLng(lat, lng))
                .addTo(map)
                .bindPopup(popupHtml);

            map.setView(L.latLng(lat, lng), 16);
        };

        let searchTimeout;
        const doSearch = () => {
            const searchQuery = document.getElementById('search-query');
            const searchResultContainer = document.getElementById('search-result');
            searchResultContainer.innerHTML = '<div class="progress" id="search-progress"><div class="indeterminate"></div></div>'

            const mapCenter = map.getCenter();
            const mapBound = map.getBounds();
            const northWest = mapBound.getNorthWest();
            const southEast = mapBound.getSouthEast();

            const toponymieParams = {
                q: searchQuery.value,
                lat: mapCenter.lat,
                lon: mapCenter.lng,
                viewbox: `${northWest.lng},${northWest.lat},${southEast.lng},${southEast.lat}`
            };

            const overlayParams = {
                q: searchQuery.value,
                bbox: `${northWest.lng},${southEast.lat},${southEast.lng},${northWest.lat}`
            };

            const allServices = [
                ...(searchQuery.value.length > 3 ? toponymieServices.map(srv => ({ srv, params: toponymieParams })) : []),
                ...overlayServices.map(srv => ({ srv, params: overlayParams }))
            ].sort((a, b) => a.srv.order_to_display_in_group - b.srv.order_to_display_in_group);

            const srvNames = allServices.map(({ srv }) => srv.name);

            Promise.all(allServices.map(({ srv, params }) => api.callService(srv.name, {...srv.params, ...params})))
                .then(results => results.reduce((acc, serviceResults) => ({...acc, ...serviceResults}), {}))
                .then(results => {
                    return srvNames.reduce((obj, key) => {
                        obj[key] = results[key];
                        return obj;
                    }, {});
                })
                .then(results => searchResultContainer.innerHTML = Handlebars.templates['search-results']({ results }));
        };

        window.search = (event) => {
            if (searchTimeout) {
                clearTimeout(searchTimeout);
            }

            if (event && event.type === 'keyup') {
                searchTimeout = setTimeout(doSearch, 600);
            } else {
                doSearch();
            }
        };
    });
}